export default __webpack_public_path__ + "static/media/el2.1bc65fee.png";